import React from "react";
import { APP_VERSION } from "../version";

export default function LoginScreen({ credentials, setCredentials, onSubmit, error }) {
  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <span className="fixed bottom-2 right-2 z-40 select-none rounded-md bg-white/80 px-2 py-1 text-xs text-gray-400 shadow-sm">
        v{APP_VERSION}
      </span>
      <div className="w-full max-w-md bg-white border border-gray-200 rounded-xl shadow-sm p-6">
        <h1 className="text-2xl font-bold text-gray-800 mb-2">Editorial Hub</h1>
        <p className="text-sm text-gray-500 mb-6">Ingresá con tu usuario para acceder al sistema.</p>

        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Usuario</label>
            <input
              type="text"
              required
              value={credentials.usuario}
              onChange={(e) => setCredentials((prev) => ({ ...prev, usuario: e.target.value }))}
              className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-indigo-400 outline-none"
              placeholder="Usuario"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Contraseña</label>
            <input
              type="password"
              required
              value={credentials.clave}
              onChange={(e) => setCredentials((prev) => ({ ...prev, clave: e.target.value }))}
              className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-indigo-400 outline-none"
              placeholder="Contraseña"
            />
          </div>

          {error ? <p className="text-sm text-red-600">{error}</p> : null}

          <button type="submit" className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-3 rounded-lg transition-colors">
            Ingresar
          </button>
        </form>
      </div>
    </div>
  );
}
